import walletMoney from "../../assets/images/wallet-money.svg";
import { axiosTokenInstance } from "../../axiosConfig/axios";
import "./payment.css";
import "react-toastify/dist/ReactToastify.css";

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(38, 38, 38, 0.5)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    alignItems: "center",
    zIndex: 9999,
  },
  box: {
    backgroundColor: "white",
    padding: "60px 20px",
    borderRadius: "24px 24px 0 0",
    width: "100%",
    border: "1px solid grey",
  },

  inner_box: {
    width: "100%",
    maxWidth: "400px",
    padding: "20px",
    borderRadius: "8px",
  },
  input: {
    width: "100%",
    padding: "15px 10px",
    marginTop: "3px",
    fontSize: "14px",
    borderRadius: "10px",
    border: "1px solid #ccc",
    outline: "none",
  },
};

const WaysOfPayment = ({ setIsOpen, setIsWaysOfPaymentOpen, promotion_id }) => {
  const order_id = localStorage.getItem("order-id");

  const payment = async () => {
    try {
      const { data } = await axiosTokenInstance.post(
        `/connector/api/users/order/fullPaid/${order_id}`,
        { payment_from: "web-view", promotion_id },
      );
      console.log(data);

      if (data?.payment_url) {
        window.location.href = data.payment_url;
      } else {
        console.error("Redirect URL not found!");
      }
    } catch (error) {
      console.error("Payment error:", error);
    }
  };

  const handleToggle = () => {
    setIsOpen(true);
    setIsWaysOfPaymentOpen(false);
  };

  return (
    <>
      <div style={styles.overlay}>
        <div style={styles.box}>
          <div className="payment-method">
            <div className="payment-option" onClick={payment}>
              <img src={walletMoney} alt="wallet-icon" />
              <p className="payment-text">دفع الطلب كامل</p>
            </div>
            <div className="payment-option" onClick={() => handleToggle()}>
              <img src={walletMoney} alt="wallet-icon" />
              <p className="payment-text">دفع جزء من الطلب</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WaysOfPayment;
